import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";

const SentRequestView = ({ show, handleClose, data }) => {
  useEffect(() => {
    AOS.init({ duration: 600, once: true });
  }, []);

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp * 1000);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatLabel = (key) => {
    return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  const excludedKeys = [
    "created_at",
    "request_sender_id",
    "request_receiver_id",
  ];
  const priorityFirst = ["sender_company_name"];
  const priorityLast = ["comment"];

  const getSortedEntries = (dataObj) => {
    const entries = Object.entries(dataObj).filter(
      ([key, value]) =>
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !excludedKeys.includes(key)
    );

    const first = entries.filter(([key]) => priorityFirst.includes(key));
    const last = entries.filter(([key]) => priorityLast.includes(key));
    const middle = entries.filter(
      ([key]) => !priorityFirst.includes(key) && !priorityLast.includes(key)
    );

    return [...first, ...middle, ...last];
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
      <Modal.Header
        closeButton
        className="text-white"
        style={{
          background: "linear-gradient(to right,rgb(66, 65, 67),rgb(1, 1, 2))",
          borderBottom: "none",
        }}
      >
        <Modal.Title className="fw-semibold text-white">
          <i className="bx bx-detail me-2"></i> Request Overview
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="bg-light">
        <div className="p-4 bg-white rounded-4 shadow-sm border">
          <div className="row g-4">
            {data &&
              getSortedEntries(data).map(([key, value], index) => {
                let displayValue = value;

                if (key === "requsted_date" || key === "updated_at") {
                  displayValue = formatDate(value);
                }

                const isFullWidth = key === "comment";
                const columnClass = isFullWidth ? "col-12" : "col-md-6";

                return (
                  <div
                    key={key}
                    className={columnClass}
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                  >
                    <div
                      className="bg-white border rounded-3 p-3 shadow-sm h-100"
                      style={{ minHeight: "50px" }}
                    >
                      <div className="text-muted  fw-semibold mb-1">
                        {formatLabel(key)}
                      </div>
                      <div className="text-dark fs-6">{displayValue}</div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SentRequestView;
